var from = "from";
var to = "to";
var night = "Night";
var night_plural = "{{numberOfNights}} Nights";
var week = "Week";
var week_plural = "{{numberOfWeeks}} Weeks";
var nightComma = ", 1 Night";
var nightComma_plural = ", {{numberOfNights}} Nights";
var nights = "1 Night";
var nights_plural = "{{numberOfNights}} Nights";
var weekComma = ", 1 Week";
var weekComma_plural = ", {{numberOfWeeks}} Weeks";
var weeks = "1 Week";
var weeks_plural = "{{numberOfWeeks}} Weeks";
var chooseDuration = "Choose your travel duration";
var chooseRangeLabel = "...and the flexible travel period";
var durationPlaceholder = "arbitrary";
var submit = "Update Search";
var offer = "Offer";
var busy = "Busy";
var available = "Available";
var advancedNight = "night";
var advancedNight_plural = "nights";
var minimumStay = "Minimum stay {{ count }} night";
var minimumStay_plural = "Minimum stay {{ count }} nights";
var invalidDateFormat = "The date is either invalid or entered in the wrong format";
var invalidDateWithFormat = "The date is either invalid or entered in the wrong format, use {{ format }}";
var invalidMinDate = "The date must be after or equal to {{ minDate }}";
var invalidMaxDate = "The date must be before or equal to {{ maxDate }}";
var datePickerModalHeader = "Travel period and duration";
var fallbackDateRange = {
	from: from,
	to: to,
	night: night,
	night_plural: night_plural,
	week: week,
	week_plural: week_plural,
	nightComma: nightComma,
	nightComma_plural: nightComma_plural,
	nights: nights,
	nights_plural: nights_plural,
	weekComma: weekComma,
	weekComma_plural: weekComma_plural,
	weeks: weeks,
	weeks_plural: weeks_plural,
	chooseDuration: chooseDuration,
	chooseRangeLabel: chooseRangeLabel,
	durationPlaceholder: durationPlaceholder,
	submit: submit,
	offer: offer,
	busy: busy,
	available: available,
	advancedNight: advancedNight,
	advancedNight_plural: advancedNight_plural,
	minimumStay: minimumStay,
	minimumStay_plural: minimumStay_plural,
	invalidDateFormat: invalidDateFormat,
	invalidDateWithFormat: invalidDateWithFormat,
	invalidMinDate: invalidMinDate,
	invalidMaxDate: invalidMaxDate,
	datePickerModalHeader: datePickerModalHeader
};

export { advancedNight, advancedNight_plural, available, busy, chooseDuration, chooseRangeLabel, datePickerModalHeader, fallbackDateRange as default, durationPlaceholder, from, invalidDateFormat, invalidDateWithFormat, invalidMaxDate, invalidMinDate, minimumStay, minimumStay_plural, night, nightComma, nightComma_plural, night_plural, nights, nights_plural, offer, submit, to, week, weekComma, weekComma_plural, week_plural, weeks, weeks_plural };
//# sourceMappingURL=date-range-input.en.t.json.js.map
